import en from "./en";
import ko from "./ko";
import vi from "./vi"

const languages = { en, ko, vi };
export default languages;
